import React, { useState, useEffect } from "react";
import {
  Route,
  Switch,
  // useRouteMatch,
  // useParams,
  // Link,
  // useLocation,
} from "react-router-dom";
import { useUserState } from "../providers/UserProvider";
// import { useMeetingListState } from "../providers/MeetingListProvider";
import ProtectedLayout from "../components/Layout/ProtectedLayout";
import { commonRoutes, userRoutes, drRoutes } from "../lib/routes";

function ProtectedRoutes(props) {
  const user = useUserState();
  // const meetingList = useMeetingListState();
  const [accountType, setaccountType] = useState("");
  // let accType = user.user_login.approve;
  // let { path, url } = useRouteMatch();
  // let { topic } = useParams();
  // console.log(`path`, path);
  // console.log(`url`, url);
  useEffect(() => {
    if (user.user_login) {
      let userTypr = user.user_login.approve;
      setaccountType(userTypr);
    }
  }, [user.user_login]);

  function renderRoutes() {
    switch (accountType) {
      case "user":
        return (
          <Switch>
            {userRoutes.map((route, index) => {
              if (route.dynamic) {
                return (
                  <Route
                    path={`${route.path}`}
                    component={route.component}
                    key={index}
                  />
                );
              } else {
                return (
                  <Route
                    exact
                    path={route.path}
                    component={route.component}
                    key={index}
                  />
                );
              }
            })}
          </Switch>
        );
      case "doctor":
        return (
          <Switch>
            {drRoutes.map((route, index) => {
              if (route.dynamic) {
                return (
                  <Route
                    path={`${route.path}`}
                    component={route.component}
                    key={index}
                  />
                );
              } else {
                return (
                  <Route
                    exact
                    path={route.path}
                    component={route.component}
                    key={index}
                  />
                );
              }
            })}
          </Switch>
        );
      default:
        return (
          <div>
            <div>
              <div>
                <div>
                  <h1>Unable to access this section</h1>
                  <p>
                    Your access to this section is blocked, if any Question
                    Contact support.
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
    }
  }

  return (
    <React.Fragment>
      <ProtectedLayout>
        <Switch>
          {commonRoutes.map((route, index) => {
            if (route.dynamic) {
              return (
                <Route
                  path={`${route.path}`}
                  component={route.component}
                  key={index}
                />
              );
            } else {
              return (
                <Route
                  exact
                  path={route.path}
                  component={route.component}
                  key={index}
                />
              );
            }
          })}
          {renderRoutes()}
        </Switch>
      </ProtectedLayout>
    </React.Fragment>
  );
}

export default ProtectedRoutes;
